// 首页接口列表

import httpRequest from '@/utils/request.js'

// 欢迎栏
export const wellcome = (params = {}) => httpRequest.httpGet({
  url: '/service/home/welcome',
  params: {
    ...params
  }
})

/** 获取最新异常列表接口 */
export const abnormalList = (params = {}) => httpRequest.httpGet({
  url: '/service/home/ex',
  params: {
    ...params
  }
})

/** 首页地图监测点列表 */
export const carrierList = (params = {}) => httpRequest.httpGet({
  url: '/service/home/carrier',
  params: {
    ...params
  }
})

/** 近况统计  使用code区分 */
export const carrierSituation = (params = {}) => httpRequest.httpGet({
  url: '/service/home/statistics',
  params: {
    ...params
  }
})

/** 地图单元详细内容点击监测点显示详细 */
export const carrierDetail = (params = {}) => httpRequest.httpGet({
  url: '/service/home/carrierProbeState',
  params: {
    ...params
  }
})

export const carrierTrace = (params = {}) => httpRequest.httpGet({
  url: '/service/home/carrierTraceState',
  params: {
    ...params
  }
})

// 监测点追踪历史轨迹过滤下拉选项获取
export const traceFilterOptions = (params = {}) => httpRequest.httpGet({
  url: '/service/share/param',
  params: {
    ...params
  }
})

// 监测点追踪历史列表
export const carrierTransportationHistory = (params = {}) => httpRequest.httpGet({
  url: '/service/home/carrier/transportation/history/page',
  params: {
    ...params
  }
})
// 监测点追踪历史轨迹查询
export const traceSearch = (params = {}) => httpRequest.httpGet({
  url: '/service/home/carrierTrace',
  params: {
    ...params
  }
})
// 首页地图点击地图单元详细内容
export const unitDetail = (params = {}) => httpRequest.httpGet({
  url: '/service/home/mapSub',
  params: {
    ...params
  }
})

// 首页地图单元与监测点位置显示
export const mapPosition = (params = {}) => httpRequest.httpGet({
  url: '/service/home/position',
  params: {
    ...params
  }
})

// 点击监测点历史追踪轨迹点详细内容
export const traceDetail = (params = {}) => httpRequest.httpGet({
  url: '/service/home/traceDetail',

  params: {
    ...params
  }
})
/**
 * 获取实时轨迹
 * @param id 监测点ID
 * @returns {Promise<unknown>}
 */
export const getRealTimeTrack = (id) => httpRequest.httpGet({
  url: '/service/home/carrierTraceCurrent',
  params: {
    id
  }
})

// 首页监测点关联映射列表
export const carrierDetailList = (params) =>
  httpRequest.httpGet({
    url: `/service/home/carrierDevice/list`,
   params: {
      ...params
    }
  })

// Dashboard资产统计
export const getAssetStatistics = (params = {}) => httpRequest.httpGet({
  url: '/service/dashboard/asset/statistics',
  params: {
    ...params
  }
})

// Dashboard客户位置
export const getCustomerPosition = (params = {}) => httpRequest.httpGet({
  url: '/service/dashboard/customer/position',
  params: {
    ...params
  }
})
// Dashboard客户位置
export const getCustomerCenter = (params = {}) => httpRequest.httpGet({
  url: '/service/dashboard/customer/center',
  params: {
    ...params
  }
})
// Dashboard可追踪资产
export const getTraceableAssets = (params = {}) => httpRequest.httpGet({
  url: '/service/dashboard/traceable/assets',
  params: {
    ...params
  }
})

// Dashboard最近告警
export const getRecentAlerts = (params = {}) => httpRequest.httpGet({
  url: '/service/dashboard/recent/alerts',
  params: {
    ...params
  }
})

// Dashboard环境趋势
export const getEnvironmentalTrends = (params = {}) => httpRequest.httpGet({
  url: '/service/dashboard/environmental/trends/data',
  params: {
    ...params
  }
})

// Dashboard设备状态
export const getDeviceStatus = (params = {}) => httpRequest.httpGet({
  url: '/service/dashboard/device/status',
  params: {
    ...params
  }
})

